import LogisticPreview from "../LogisticBidSubmission/LogisticPreview";

const Preview = (props) => {
  return <LogisticPreview {...props} />;
};

export default Preview;
